<template>
  <div>
    <v-tabs v-model="tab"
    flat color="primary" dark
    grow height="40"
    fixed-tabs
    >
    <v-tab href="#tab-0">
      Requests ({{ joinReq.length }})
    </v-tab>
    <v-tab href="#tab-1">
      Users ({{ users.length }})
    </v-tab>
    <!-- <v-tab href="#tab-2">
    Access Control
  </v-tab> -->
</v-tabs>
<v-container class="pa-1" grid-list-md>
  <v-layout row wrap>
    <v-flex xs12>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-0">
          <v-layout>
            <v-flex xs12 md9 offset-sm3 class="mx-auto">
              <div v-if="joinReq.length === 0" class="info--text text-xs-center">No requests</div>
              <v-card v-for="(req, k) in joinReq" :key="k" class="ma-1 mb-2">
                <v-card-text class="pa-1">
                  <v-layout row wrap>
                    <v-flex xs6 style = "border-right:1px solid lightgray" class="pa-2">
                      <div class="title"> {{ req.cust_name }}</div>
                      <div class="subheading" v-if="!req.is_other_user"> {{ req.block_nm + ' ' + req.unit_no }}</div>
                      <div> {{ req.ownership }}</div>
                    </v-flex>
                    <v-flex xs6 class="pl-3 pa-2">
                      <div class="title">{{ req.role_name }}</div>
                      <div class="subheading"> {{ req.contact_phone }}</div>
                      <div> {{ req.contact_email }}</div>
                    </v-flex>
                    <v-flex xs12 v-if="req.show_rej">
                      <span color="grey" style="float:right">
                        <v-btn class="ma-0" icon @click.stop="req.rej_reason='', req.show_rej=false">
                          <v-icon small>close</v-icon>
                        </v-btn>
                      </span>
                      <v-text-field
                      hide-details
                      label="Rejection reason"
                      v-model="req.rej_reason"
                      >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="pa-1">
                <v-spacer></v-spacer>
                <v-btn small flat :color="req.show_rej?'accent':''" @click="acceptRejReq('reject-req', req), req.show_rej=true">Reject</v-btn>
                <v-btn small flat :color="!req.show_rej?'accent':''" @click="acceptRejReq('accept-req', req)">Accept</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab-item value="tab-1">
        <v-layout>
          <v-flex xs12>
            <v-card flat>
              <v-card-title class="pt-2">
                <v-layout row wrap>
                  <v-flex xs4>
                    <v-text-field
                    class="pa-0 mt-1"
                    append-icon="search"
                    :placeholder="$vuetify.breakpoint.smAndUp?'Search by name, unit no, status, etc.':'Search'"
                    single-line
                    hide-details
                    v-model="search"
                    clearable
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs1 class="text-xs-right">
                    <v-icon class="pt-2">filter_list</v-icon>
                  </v-flex>
                  <v-flex xs4 class="pt-0">
                    <v-select
                    class="pt-1"
                    v-model="filterList.role_pair"
                    :items="roleForFilter"
                    item-text="role_name"
                    item-value="role_id"
                    label="Roles"
                    return-object
                    hide-details
                    small-chips
                    clearable
                    dense
                    multiple
                    @click:clear="clearFilter()"
                    @input="applyFilter()"
                    ></v-select>
                  </v-flex>
                  <v-flex xs3>
                    <v-download-as
                    :headers="userHeadSm"
                    :items="users"
                    title="User list"
                    landscape="true"
                    ></v-download-as>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="pa-1">
                <v-data-table
                :headers="$vuetify.breakpoint.smAndUp?userHeadSm:userHead"
                :items="users"
                disable-initial-sort
                class="elevation-3"
                :rows-per-page-items = "[10,25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                :pagination.sync="pagination"
                :search="search"
                >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td v-if="$vuetify.breakpoint.smAndUp" class="px-2"><v-avatar size="36px" slot="activator">
                      <img :src="config.STATIC_FILES_DIR + props.item.avatar_url"/>
                    </v-avatar>
                  </td>
                  <td class="pa-1">{{ props.item.cust_name }}
                    <span class="caption grey--text" v-if="props.item.is_admin">
                      <br />Administrator
                    </span>
                    <span class="caption grey--text" v-if="props.item.role_name !== 'Resident'">
                      <br />{{ props.item.role_name }}
                    </span>
                  </td>
                  <td v-if="$vuetify.breakpoint.smAndUp" class="pa-1">{{ props.item.contact_phone }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp" class="pa-1">{{ props.item.contact_email }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp" class="pa-1">{{ props.item.block_nm }}</td>
                  <td class="pa-1">{{ props.item.unit_no }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp" class="pa-1">{{ props.item.ownership }} </td>
                  <td class="pa-1">{{ !props.item.is_active ? 'Disabled': props.item.is_other_user ? props.item.rel_status_if_other_user : props.item.rel_status }}
                  </td>
                  <v-menu bottom left class="mt-2">
                    <v-btn small icon slot="activator" class="ma-0">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                    <v-list>
                      <v-list-tile v-if="props.item.is_other_user ? props.item.rel_status_if_other_user === 'Linked' : props.item.rel_status === 'Linked'" @click="userUpdate('delink', props.item)">
                        <v-list-tile-avatar><v-icon>close</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Delink from this {{ props.item.is_other_user ? 'community' : 'unit' }} </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-else-if="props.item.is_other_user ? props.item.rel_status_if_other_user === 'Delinked' : props.item.rel_status === 'Delinked'" @click="userUpdate('link', props.item)">
                        <v-list-tile-avatar><v-icon>link</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Link to this {{ props.item.is_other_user ? 'community' : 'unit' }} </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-if="props.item.is_active" @click="userUpdate('disable', props.item)">
                        <v-list-tile-avatar><v-icon>visibility_off</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Disable access</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-else @click="userUpdate('enable', props.item)">
                        <v-list-tile-avatar><v-icon>accessibility</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Enable access</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-if="props.item.is_admin" @click="userUpdate('noadmin', props.item)">
                        <v-list-tile-avatar><v-icon>account_circle</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Remove admin access</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile v-else @click="userUpdate('admin', props.item)">
                        <v-list-tile-avatar><v-icon>supervisor_account</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Make an admin</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile :disabled="!props.item.is_other_user" @click="updateRoles(props.item)">
                        <v-list-tile-avatar><v-icon>person</v-icon></v-list-tile-avatar>
                        <v-list-tile-title>Change user role</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-tab-item>
</v-tabs-items>

<!-- user info dialog -->
<v-layout row justify-center>
  <v-dialog v-model="dlgInfo" max-width="500px" scrollable>
    <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
      <v-card flat>
        <v-card-title class="title">User details</v-card-title>
        <v-card-text class="pt-0">
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="dlgInfo = false">Close</v-btn>
          <v-btn type="submit" color="accent" flat>Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</v-layout>

<!-- change user roles dialog -->
<v-dialog v-model="showRolesList" scrollable persistent max-width="400px">
  <v-card>
    <v-card-title class="title grey lighten-4">
      Change user role
    </v-card-title>
    <v-card-text>
      <v-flex xs12>
        <v-select
        v-model="lChangedRoles.role_pair"
        :items="roles"
        item-text="role_name"
        item-value="role_id"
        label="Roles"
        return-object
        hide-details
        ></v-select>
      </v-flex>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-spacer></v-spacer>
      <v-btn flat @click.stop="showRolesList = false">close</v-btn>
      <v-btn flat class="accent--text" @click="saveRoles()">save</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<div v-if="load" style="position:absolute; top:20%; left:50%">
  <v-progress-circular indeterminate color="primary"></v-progress-circular>
</div>

</v-flex>
</v-layout>
</v-container>
</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      // common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      handy: handy,
      config: config,
      rules: handy.rules,
      // component specific
      tab: 'tab-0',
      joinReq: [],
      users: [],
      roles: [],
      dlgInfo: false,
      search: '',
      userHead: [
        { text: 'Name', value: 'cust_name', width: '250px', class: 'px-2' },
        { text: 'Unit', value: 'unit_no', width: '25px', class: 'pa-1' },
        { text: 'Status', value: 'rel_status', width: '25px', class: 'pa-1' },
        { text: '', sortable: false, value: 'action', class: 'pa-1' }
      ],
      userHeadSm: [
        { text: 'Avatar', value: 'avatar_url', class: 'px-2' },
        { text: 'Name', value: 'cust_name', class: 'pa-1' },
        { text: 'Mobile', value: 'contact_phone', class: 'pa-1' },
        { text: 'E-Mail', value: 'contact_email', class: 'pa-1' },
        { text: 'Block', value: 'block_nm', class: 'pa-1' },
        { text: 'Unit', value: 'unit_no', class: 'pa-1' },
        { text: 'Ownership', value: 'ownership', class: 'pa-1' },
        { text: 'Status', value: 'rel_status', class: 'pa-1' },
        { text: '', sortable: false, value: 'action', class: 'pa-1' }
      ],
      pagination: { rowsPerPage: 25 },
      showRolesList: false,
      lChangedRoles: [],
      // filter
      showFilter: false,
      filterList: {},
      enabledFilter: false,
      roleForFilter: []
    }
  },
  mounted () {
    // load lists
    this.loadJoinReq()
    this.loadUsers()
    this.loading()
    this.filterList = this.getEmptyFilter()
    this.loadRoles()
  },
  methods: {
    msg (m, isError = false) {
      this.sbarCol = isError ? 'error' : 'success'
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
      setTimeout(() => {
        this.load = false
      }, 500)
    },
    acceptRejReq (curAct, curReq) {
      if (curAct === 'reject-req' && !curReq.rej_reason) {
        if (curReq.show_rej) {
          this.msg('Enter the reason for rejection', true)
        } else {
          this.$forceUpdate()
        }
        return
      }
      if (curAct === 'accept-req' && curReq.ownership && curReq.ownership.toLowerCase().includes('tenant') && !curReq.is_rented) {
        if (!confirm('Please note that the house will be marked as rented upon accepting tenant\'s joining request')) {
          return
        }
      }
      // accept or reject
      curReq.actioned_by = config.USER_ID
      this.axios.post(config.API_URL + '/admin/' + curAct, curReq)
      .then(response => {
        // refresh list in front end
        var idx = this.joinReq.findIndex(rec => rec.user_id === curReq.user_id && rec.unit_id === curReq.unit_id)
        this.joinReq.splice(idx, 1)
        this.loadUsers()
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    userUpdate (curAct, curUser) {
      if (curAct === 'delink' && !confirm('Sure, you want to disassociate the user from ' + (curUser.is_other_user ? 'community' : 'unit') + ' "' + (curUser.is_other_user ? config.COMM_NAME : curUser.unit_no) + '"?')) {
        return
      }
      if (curAct === 'disable' && !confirm('Sure, you want to disable the user "' + curUser.cust_name + '"?')) {
        return
      }

      if (curAct === 'link' && curUser.ownership && curUser.ownership.toLowerCase().includes('tenant') && !curUser.is_rented) {
        if (!confirm('Please note that the house will be marked as rented upon linking the tenant')) {
          return
        }
      }

      // accept or reject
      curUser.actioned_by = config.USER_ID
      this.axios.post(config.API_URL + '/admin/' + curAct, curUser)
      .then(response => {
        // refresh list in front end
        var idx = this.users.findIndex(rec => rec.user_id === curUser.user_id && rec.unit_id === curUser.unit_id)
        if (curAct === 'delink') {
          if (curUser.is_other_user) {
            this.users[idx].rel_status_if_other_user = 'Delinked'
          } else {
            this.users[idx].rel_status = 'Delinked'
          }
        } else if (curAct === 'link') {
          if (curUser.is_other_user) {
            this.users[idx].rel_status_if_other_user = 'Linked'
          } else {
            this.users[idx].rel_status = 'Linked'
          }
        } else if (curAct === 'disable') {
          this.users[idx].is_active = false
        } else if (curAct === 'enable') {
          this.users[idx].is_active = true
        } else if (curAct === 'noadmin') {
          this.users[idx].is_admin = false
        } else if (curAct === 'admin') {
          this.users[idx].is_admin = true
        }
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadJoinReq () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID,
          is_admin: config.IS_ADMIN
        }
      }
      this.axios.get(config.API_URL + '/getJoiningRequest/', qry)
      .then(response => {
        this.joinReq = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.joinReq = []
      })
    },
    loadUsers () {
      var qry = {
        params: {
          comm_id: config.COMM_ID,
          filter: this.filterList
        }
      }
      this.axios.get(config.API_URL + '/getUsersListByCommId/', qry)
      .then(response => {
        response.data.forEach(rec => {
          if (rec.show_inactive_user === 0) {
            this.users = response.data.filter(rec => rec.rel_status === 'Linked' && rec.is_active === 1 || rec.rel_status_if_other_user === 'Linked' && rec.is_active === 1)
          } else {
            this.users = response.data
          }
        })
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.users = []
      })
    },
    loadRoles () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getRolesByCommId/', qry)
      .then(response => {
        this.roleForFilter = response.data
        this.roles = response.data.filter(rec => rec.role_type !== 'RWA' && rec.role_type !== 'Resident')
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.roles = []
      })
    },
    updateRoles (curUser) {
      this.lChangedRoles = Object.assign({}, curUser)
      this.lChangedRoles.role_pair = {role_id: curUser.role_id, role_name: curUser.role_name}
      this.loadRoles()
      this.showRolesList = true
    },
    saveRoles () {
      this.axios.post(config.API_URL + '/changedRoles/', this.lChangedRoles)
      .then(response => {
        // refresh list in front end
        this.loadUsers()
        this.showRolesList = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    getEmptyFilter () {
      var filter = {
        role_pair: []
      }
      return filter
    },
    applyFilter () {
      if (this.filterList.role_pair && this.filterList.role_pair.length > 0) {
        this.loadUsers()
        this.enabledFilter = true
        this.showFilter = false
      }
    },
    clearFilter () {
      this.filterList.role_pair = []
      this.enabledFilter = false
      this.showFilter = false
      this.loadUsers()
    }
  }
}
</script>



// WEBPACK FOOTER //
// Users.vue?0a6a5420